<div class="cpi-warning">
  <h4>WARNING!</h4>
  <p>You have entered a BUYER CPI that is greater than $10.</p>
  <ps-ui-cpi-override-confirmation
    type="buyer"
    color="warning"
    [borderless]="true"
    [bold]="true"
    (confirm)="onConfirmation($event)"
    [surveyId]="surveyId"
    [newCpi]="newCpi"
  ></ps-ui-cpi-override-confirmation>
  <div class="padding10"></div>
</div>
